import { footerLinks, mastheadMeta } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50 text-secondary-950 text-xl font-heading font-bold">
                料
              </span>
              <span className="font-heading font-bold text-2xl">黑料看料</span>
            </div>
            <p className="mt-5 font-label text-sm leading-relaxed text-background-50/70 max-w-md">
              把散落的线索整理成可检索的合集，把每一条判断的依据摊开给读者看。
              深挖隐情秘闻，还原实情底细，是我们一直坚持的节奏。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["深挖", "合集", "证据链", "讨论区"].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1 rounded-full text-xs font-label bg-background-50/10 text-background-50/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-base font-semibold text-background-50">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="font-label text-sm text-background-50/65 hover:text-accent-300 transition-colors"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50">
              值班与更正
            </h4>
            <p className="mt-4 font-label text-sm leading-relaxed text-background-50/65">
              {mastheadMeta.date}
              <br />
              编辑部每日 08:00 与 20:00 两次更新合集与时间线。
              若内容存在出入，欢迎通过讨论区提交更正。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-file-list-3-line", "ri-links-line"].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/10 text-background-50/80 hover:bg-accent-500 hover:text-secondary-950 transition-colors cursor-pointer"
                  aria-label="频道"
                >
                  <i className={icon}></i>
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-background-50/50">
            © 2026 黑料看料 · 本站内容为线索整理与读者讨论，不代表司法或官方结论
          </p>
          <p className="font-label text-xs text-background-50/50">
            {mastheadMeta.edition} · 保留所有权利
          </p>
        </div>
      </div>
    </footer>
  );
}